module.exports = __webpack_public_path__ + "img/52.36fc20df.jpg";